(function () {
  document.querySelectorAll('.drv-hfood').forEach(function (root) {
    const overlay = root.querySelector('[data-drv-food-overlay]');
    const title = root.querySelector('[data-drv-food-ptitle]');
    const text = root.querySelector('[data-drv-food-ptext]');
    if (!overlay) return;
    overlay.hidden = false;

    function close() { overlay.classList.remove('is-open'); }

    root.querySelectorAll('.drv-hfood__tile').forEach(function (tile) {
      tile.addEventListener('click', function () {
        title.textContent = tile.dataset.drvFoodTitle || '';
        const rich = tile.querySelector('template[data-drv-food-rich]');
        if (rich) text.innerHTML = rich.innerHTML;
        else text.textContent = tile.dataset.drvFoodText || '';
        text.hidden = !text.textContent.trim();
        overlay.classList.add('is-open');
      });
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('[data-drv-food-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
})();
